module.exports = __webpack_public_path__ + "static/media/Adobe_Experience_Cloud_logo_RGB.12e9d097.svg";